import React, { useEffect, useState } from "react";
import "./PayDetailTab.scss";
import { Tabs, TabsProps } from "antd";
import TabPay from "./TabPay/TabPay";
import CancelPay from "./CancelPay/CancelPay";
import Refunds from "./Refunds/Refunds";
import Prepay from "./Prepay/Prepay";
import Exemptions from "./Exemptions/Exemptions";
import { tabKeys } from "types/enums";
import HistoryPay from "./HistoryPay/HistoryPay";
import TicketPay from "./TicketPay/TicketPay";
import TabPayExamination from "./TabPay/TabPayExamination";
import Voucher from "./Voucher/Voucher";

const PayDetailTab = ({ currentTab, setCurrentTab, data }) => {
  const [type, setType] = useState(0);
  const handleChange = (activeKey) => {
    setCurrentTab(activeKey);
    if (activeKey === tabKeys.PAYCHILD.PAY_CHILD) {
      setType(0);
    } else setType(1);
  };
  const items: TabsProps["items"] = [
    {
      key: tabKeys.PAYCHILD.PAY_CHILD,
      // label: `Thanh toán ngoại trú`,
      label: `Thanh toán ngoại trú`,
      children: <TabPay dataPatient={data} type={type} />,
    },
    {
      key: tabKeys.PAYCHILD.PAY_RESIDENT,
      label: `Thanh toán nội trú`,
      children: <TabPayExamination dataPatient={data} type={type} />,
    },
    {
      key: tabKeys.PAYCHILD.PAYMENT,
      label: `Tạm ứng`,
      children: <Prepay />,
    },
    {
      key: tabKeys.PAYCHILD.CANCEL_PAY,
      label: `Huỷ thanh toán`,
      children: <CancelPay />,
    },
    {
      key: tabKeys.PAYCHILD.REFUNDS,
      label: `Hoàn phí`,
      children: <Refunds />,
    },
    // {
    //   key: tabKeys.PAYCHILD.EXEMPTIONS,
    //   label: `Miễn giảm`,
    //   children: <Exemptions />,
    // },
    {
      key: tabKeys.PAYCHILD.HISTORY_PAY,
      label: `Lịch sử thanh toán`,
      children: <HistoryPay />,
    },
    {
      key: tabKeys.PAYCHILD.TICKET_PAY,
      label: `Thẻ khám`,
      children: <TicketPay />,
    },
    {
      key: tabKeys.PAYCHILD.VOUCHER,
      label: `Chương trình ưu đãi`,
      children: <Voucher tabKey={currentTab} />,
    },
  ];
  return (
    <div className="pay-detail-container">
      <div className="container">
        <Tabs onChange={handleChange} activeKey={currentTab} items={items} />
      </div>
    </div>
  );
};

export default PayDetailTab;
